import jsPDF from 'jspdf'
import 'jspdf-autotable'
export const pdfTermsAndConditionsMixin = {
  methods: {
    downloadTermsAndConditionsPDF(name, lastname, creation_date) {
        const pdf = new jsPDF('p', 'pt', 'a4');
        const user = name + ' ' + lastname
        const dateCreation = 'Accepted: ' + creation_date

        const logo = require('@/assets/images/logo-h.png')

        const doc = new jsPDF()
        var imgLogo = new Image()
        imgLogo.src = logo


        pdf.addImage(imgLogo, 'JPEG', 20, 20, 185, 50);
        pdf.setFontSize(10);
        pdf.text(280, 30, user);
        pdf.text(280, 45, dateCreation);


        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(0, 89, 400, 18, 'F');

        pdf.setFontSize(14);
        pdf.setFontType("bold");
        pdf.setTextColor(255);
        pdf.text(215, 103, 'TERMS AND CONDITIONS');
        pdf.setFontSize(10);
        pdf.text(20, 103, 'Last Updated: 02/02/2023');

        pdf.setTextColor(100);

        pdf.setFontType("normal");
        pdf.setFontSize(9);

        pdf.text("These Oliverlist Terms and Conditions (the “General Conditions”) govern the relationship between Aivoni, a société, par actions" , 20, 130);
        pdf.text("simplifiée, registered with the Trade and Commercial Register of Nanterre under the number 808 785 166, with a share", 20, 145);
        pdf.text("capital of 20,000 euros, whose head office is located at 4 Avenue JB Clément 92100, Boulogne-Billancourt, France (“Aivoni”)", 20, 160);
        pdf.text("and any natural or legal person who has subscribed an account on the solution published by Oliverlist (the “Client”).", 20, 175);

        pdf.text("Hereinafter collectively referred to as the “Parties” and individually referred to as a “Party”.", 20, 200);

        // 1 Definitions
        pdf.setFontType("bold");
        pdf.text("1.  Definitions", 20, 240);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 250, 540, 1.5, 'F');

        pdf.text("", 20, 200);
        pdf.setFontSize(10);
        pdf.setFontType("normal");

        pdf.text("The terms and expressions which first letter is a capital one, in the General Conditions, have the meaning defined in this ", 20, 270);
        pdf.text("article, used either as singular or plural:", 20, 285);

        pdf.text("1.   “Authorized Users” shall mean the identified user, a natural person authorized to access Oliverlist. The Authorized", 35, 325);
        pdf.text(" User may be an employee, agent and/or service provider of the Client.", 45, 340);

        pdf.text("2.   “Client Data” shall mean the data relating to the Client’s prospects and client obtained via Oliverlist on the basis of the ", 35, 365);
        pdf.text("information provided by the Client.", 45, 380);

        pdf.text("3.   “Confidential Information” shall mean any information communicated (written, orally or by any other mean) " ,35,400)
        pdf.text("directly or indirectly by the Client to Aivoni prior or after the General Conditions’ entry into", 45,415)
        pdf.text("force including, without limitations, the information related to the Services as well as the operations,", 45,430)
        pdf.text("processes, plans, know-how, commercial secrets, inventions, techniques, commercial", 45, 445)
        pdf.text("opportunities, and activities of the Client.",45,460)

        pdf.text("4.   “Commission” shall mean the the sums due by the Client to Aivoni as specified in the Order with respect", 35, 480);
        pdf.text("to Services relating to actual appointments between the Client and its prospects as generated through Oliverlist.",45,495)

        pdf.text("5.   “Force Majeure” shall mean the events external to the Parties, unpredictable and unstoppable, as defined by French",35,515)
        pdf.text("case law, the following events shall be deemed to constitute a case of Force Majeure (without purporting to be an",45,530)
        pdf.text("exhaustive list): war (declared or not); terrorist act; invasion; rebellion; blockade; sabotage or act of vandalism;",45,545)
        pdf.text("strike or social dispute, total or partial, external to both Parties; bad weather (in particular flooding, ",45,560)
        pdf.text("storms and hurricanes); events declared as “natural disasters”; zombie invasion; fire; epidemic; transport or ",45,575)
        pdf.text("supply blockades (particularly energy); failure of electrical energy, heating, air conditioning supplies, of the",45,590)
        pdf.text("telecommunication or data transport network; satellite failure.",45, 605)

        pdf.text("6.   “General Terms of Use” shall mean the operating manuals, user instructions, technical literature, and all",35, 625)
        pdf.text("other documents regarding the use of Oliverlist, in any form, provided to the Client by Aivoni under the ",45, 640)
        pdf.text("General Conditions available at this URL.",45, 655)


        pdf.text("7.   “Licence Fee” shall mean the sums due by the Client to Aivoni as specified in the Order with respect to Services ",35, 675)
        pdf.text("relating to the Client Data.",45, 690)


        pdf.text("8.   “Oliverlist” shall mean the software solution developed and published by Aivoni which allows to ",35, 710)
        pdf.text("obtain the Client Data.",35, 725)

        pdf.text("9.   “Order” shall mean the Services proposal submitted by Aivoni and accepted by the Client, through Oliverlist.",35, 745)

        pdf.text("10.  “Services” shall mean the services provided by Oliverlist, as specified in the Order, relating to lead generation leading ",35, 765)
        pdf.text("to B2B appointments with Client’s prospects and/or additional features relating to the Client Data.", 45, 780)

        pdf.addPage()

        // 2 Purpose
        pdf.setFontType("bold");
        pdf.text("2.  Purpose", 20, 50);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 60, 540, 1.5, 'F');

        pdf.setFontSize(10);
        pdf.setFontType("normal");

        pdf.text("The purpose of the General Conditions is to define the terms and conditions under which Aivoni in consideration ", 20, 90)
        pdf.text("of the payment of the License Fee, grants the Client the right to use Oliverlist.", 20, 105);


         // 3 Duration
         pdf.setFontType("bold");
         pdf.text("3.  Duration", 20, 130);
         pdf.setDrawColor(0);
         pdf.setFillColor(81, 85, 236);
         pdf.rect(20, 140, 540, 1.5, 'F');

         pdf.setFontType("normal");

        pdf.text("The General Conditions shall enter into force on the date of signature of the first Order for an indefinite duration.", 35, 165)

        pdf.text("The Client may terminate the Order directly on its account on the platform Oliverlist. The termination ", 35, 190)
        pdf.text("will take effect on the monthly anniversary of the activation of the Services. ", 35, 205)


        // 4 Access and use of Oliverlist
        pdf.setFontType("bold");
        pdf.text("4.  Access and use of Oliverlist", 20, 235);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 245, 540, 1.5, 'F');

        pdf.setFontType("normal");

         pdf.text("The General Conditions shall enter into force on the date of signature of the first Order for an indefinite duration.", 35, 265)

         pdf.text("The Client may terminate the Order directly on its account on the platform Oliverlist. The termination ", 35, 285)
         pdf.text("will take effect on the monthly anniversary of the activation of the Services. ", 35, 300)

         pdf.text("1.  Initialisation of Oliverlist", 35, 320)
         pdf.text("In order to register with Oliverlist, the Client must fill in the fields of the registration form with complete and ", 35, 335)
         pdf.text("accurate data and accept the General Conditions.", 35, 350)

         pdf.text("The information provided by the Client is used to create the Client’s main user account on Oliverlist. During this ", 35, 370)
         pdf.text("phase of creating the main account, the Client chooses the login and the password that will be attached to it. When ", 35, 385)
         pdf.text("choosing passwords, Aivoni advises the Client to respect the recommendation of the French National Commission for ", 35, 400)
         pdf.text("Information Technology and Civil Liberties (CNIL) on passwords in order to guarantee a minimum level of security ", 35, 415)
         pdf.text("(at least twelve characters and four different types: lower case, upper case, numbers and special characters).", 35, 430)

         pdf.text("In the event of an incomplete or erroneous declaration, the Client’s and Authorized Users’ accounts may be ", 35, 450)
         pdf.text("closed, ipso jure, without prior notice or formality. In any case, the Client agrees to hold Aivoni harmless against all ", 35, 465)
         pdf.text("consequences that may result from this incomplete or erroneous declaration.", 35, 480)

         pdf.text("When the Client is an individual, he/she declares and guarantees that he/she is using Oliverlist for his/her professional ", 35, 500)
         pdf.text("activity and that, as such, he/she cannot be qualified as a consumer in the sense of the preliminary article of the ", 35, 515)
         pdf.text("French Consumer Code", 35, 530)


         pdf.text("2.  Authorized Users", 35, 550)

         pdf.text("When the Client is a legal entity, it is authorized to make its personal account available to the Authorized User.", 35, 565)

         pdf.text("The Client undertakes to ensure that the Authorized Users are competent natural persons, familiar with the use of ", 35, 580)
         pdf.text("computer tools, professionals in online marketing and informed by the Client of all issues relating to the processing ", 35, 600)
         pdf.text("of personal data and their use in the context of advertising and/or communication activities.", 35, 615)

         pdf.text("3.  Login/password of the Authorized Users", 35, 635)

         pdf.text("The Client acknowledges and accepts that it is not possible to access Oliverlist without entering a login and ", 35, 650)
         pdf.text("password. The Client is solely responsible for the security of the logins and passwords provided by Aivoni. ", 35, 665)
         pdf.text("The Client undertakes to inform Aivoni promptly of any unauthorized access, whether actual or suspected, to a login, ", 35, 680)
         pdf.text("password at the address contact@oliverlist.com", 35, 695)

         pdf.text("Any action performed via a login assigned to the Client will be deemed to have been performed by the ", 35, 715)
         pdf.text("Client, unless the Client has previously reported the login concerned as lost or stolen, thus allowing Aivoni", 35, 730)
         pdf.text("a reasonable period of time to deactivate the said login.", 35, 745)

         pdf.text("In this context, the Client is responsible for the compliance of each of its Authorized Users with the ", 35, 765)
         pdf.text("General Conditions.`", 35, 780)

         pdf.addPage()

        // 5 Description of the Services
        pdf.setFontType("bold");
        pdf.text("5.  Description of the Services", 20, 50);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 60, 540, 1.5, 'F');

        pdf.setFontSize(10);
        pdf.setFontType("normal");

        pdf.text("1. Access to the Services", 35, 80);
        pdf.text("Oliverlist is a software solution that allows to search and obtain company data of the prospects and/or clients ", 35, 95);
        pdf.text("of the Client in order to allow it to create targeting campaigns.", 35, 110);

        pdf.text("The Client shall not share any of the accesses of an Authorized User with a third party. In this context, the ", 35, 130);
        pdf.text("Client is responsible for the respect of the General Conditions by each of its Authorized Users.", 35, 145);

        pdf.text("The Client acknowledges that it has thoroughly read the General Terms of Use available hereafter at this URL and ", 35, 165);
        pdf.text("agrees to be bound by them.", 35, 180);

        pdf.text("2. Right to Use Oliverlist – Intellectual Property", 35, 200);
        pdf.text("Aivoni, in consideration for the payment of the License Fee, grants the Client and the Authorized Users, for the ", 35, 215);
        pdf.text("term of the General Conditions, the non-exclusive, personal, non-transferable right to use Oliverlist in accordance with ", 35, 230);
        pdf.text("the General Conditions. ", 35, 245);

        pdf.text("The Client is responsible for the compliance of the Users with the General Conditions and may not transfer the ", 35, 265);
        pdf.text("licence in any way whatsoever without the prior consent of Aivoni.", 35, 280);

        pdf.text("According to the right of use of Oliverlist, the Client and the Authorized Users are expressly prohibited to:", 35, 300);

        pdf.text("I. analyse, or have a third party analyse, in the sense of observing, studying, and testing, the operation of ", 45, 320);
        pdf.text("Oliverlist with a view to identifying the ideas and principles on which the elements of the program are based when ", 45, 335);
        pdf.text("Oliverlist is carrying out the tasks of loading, displaying, operating, transmitting or storing;", 45, 350);

        pdf.text("II.  in the situation where it would have had access to the source code for any reason whatsoever, make use ", 45, 370);
        pdf.text("of the said source code in any way whatsoever with the exception of the right granted by article L. 122-6-1 of the ", 45, 385);
        pdf.text("French Intellectual Property Code any interaction of Aivoni in this respect being subject to payment by this latter of ", 45, 400);
        pdf.text("the associated costs;", 45, 415);

        pdf.text("III. modify, improve, translate Oliverlist, including for the purposes of correcting bugs and errors, Aivoni ", 45, 435);
        pdf.text("exclusively reserving this right in accordance with article L. 122-6-1 I 2° of the French Intellectual Property Code;", 45, 450);

        pdf.text("IV. transfer, let, sub-let, sell, pledge, or transfer all or part of the title to Oliverlist in any way whatsoever;", 45, 470);

        pdf.text("V. not provide services through Oliverlist to any third party – other than a User – in any manner, including ", 45, 485);
        pdf.text("but not limited to service bureau, application service providing (ASP), software as a service (SaaS) or outsourcing.", 45, 500);

        pdf.text("3. Know-how", 35, 520);
        pdf.text("Any ideas, know-how, or techniques that may be developed by Aivoni including any enhancements or modifications ", 35, 535);
        pdf.text("made to Aivoni’s computer software programs, shall be the sole property of Aivoni. Aivoni may at its sole discretion ", 35, 550);
        pdf.text("develop, use, market, and license any software or data processing material that is similar or related to Aivoni’s ", 35, 565);
        pdf.text("developments for the Client. Aivoni will have no obligation to disclose any ideas, know-how, or techniques that may be ", 35, 580);
        pdf.text("developed by Aivoni and that Aivoni considers as being proprietary and confidential.", 35, 595);


        //  6. Financial Conditions

        pdf.setFontType("bold");
        pdf.text("6. Financial Conditions", 20, 620);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 630, 540, 1.5, 'F');

        pdf.setFontSize(10);
        pdf.setFontType("normal");



        pdf.text("1. Licence Fee & Commission",  35, 650)
        pdf.text("Access to Oliverlist is subject to the provision by the Client of a valid payment method as set out under the General ",  35, 665)
        pdf.text("Terms of Use.",  35, 680)

        pdf.text("In consideration for use to Oliverlist, the Client shall pay Aivoni the Commission and, if applicable, the Licence Fee.",  35, 700)

        pdf.text("The Commission is calculated according to the number of appointments scheduled by the Client through Oliverlist ",  35, 720)
        pdf.text("under the conditions specified in the General Terms of Use.",  35, 735)

        pdf.text("The License Fee is determined upon subscription of the corresponding Service through Oliverlist.",  35, 755)

        pdf.addPage()

        pdf.text("2. Payment terms",  35, 60)
        pdf.text("For the provision of Services, (i) the Licence Fee is payable upfront on a monthly basis; and (ii) the Commission ",  35, 75)
        pdf.text("shall be invoiced and due once an appointment is deemed as actual and shall be paid under the conditions set out in the ",  35, 90)
        pdf.text("General Terms of Use.",  35, 105)

        pdf.text("The License Fee and/or Commission do not include any and all applicable taxes, customs, tariffs, value-added tax or ",  35, 125)
        pdf.text("any other applicable taxes, which shall be paid by the Client in addition.",  35, 140)

        pdf.text("Would all or part of the Licence Fee and/or Commission not be paid within the contractual time limits:",  35, 155)

        pdf.text("I. any sum that remains unpaid shall automatically be subject to interest, accruing on a daily basis",  45, 175)
        pdf.text(" until the date  of full payment of the principal, interest, expenses and additional costs, at a rate equal to five (5) ",  45, 190)
        pdf.text(" times the applicable statutory rate of interest, and this with no further notice required and without prejudice to  ",  45, 205)
        pdf.text("any claim for compensation that Aivoni shall reserve the right to seek by legal means;",  45, 220)

        pdf.text("II. Aivoni reserves the right, at its sole discretion, with or without notice, to suspend performance of any ",  45, 240)
        pdf.text("Service, current or future, and this until full payment of outstanding sums;",  45, 255)

        pdf.text("III. Any delay in the payment of invoices will result in the immediate application of an annual interest rate ",  45, 270)
        pdf.text("of 12% on the unpaid amounts as well as forty (40) euros per invoice for collection costs, in accordance ",  45, 295)
        pdf.text("with art. L 4414-10 of the French Commercial Code ; and",  45, 310)

        pdf.text("IV. all sums that remain due for payment by the Client to Aivoni shall become immediately payable.",  45, 330)

        //7. Undertakings of Aivoni

        pdf.setFontType("bold");
        pdf.text("7. Undertakings of Aivoni", 20, 355);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 365, 540, 1.5, 'F');

        pdf.setFontSize(10);
        pdf.setFontType("normal");

        pdf.text("The Services will be provided under the General Conditions by Aivoni, which undertakes, unless otherwise ", 35, 385)
        pdf.text("expressly stated, to exercise its reasonable endeavours.", 35, 400)

        pdf.text("Unless otherwise expressly stipulated, Aivoni’s obligations under the General Conditions are obligations of means.", 35, 420)

        pdf.text("Aivoni is committed to ensuring that all its staff apply their know-how and knowledge to the proper execution", 35, 440)
        pdf.text("of Services. In the event of difficulties in the provision of Services, Aivoni undertakes to inform the Client", 35, 455)
        pdf.text(" immediately.", 35, 470)

        pdf.text("Aivoni reserves the right to modify at any time the characteristics of its technical infrastructures, the ", 35, 490)
        pdf.text("choice of its technical suppliers and the composition of its teams.", 35, 505)

        //8. Undertakings of the Client
        pdf.setFontType("bold");
        pdf.text("8. Undertakings of the Client", 20, 530);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 540, 540, 1.5, 'F');

        pdf.setFontSize(10);
        pdf.setFontType("normal");

        pdf.text("The Client shall:", 35, 555)

        pdf.text("I. strictly comply with the user instructions set forth in the General Terms of Use;", 45, 575)

        pdf.text("II. not to import into Oliverlist any data that may damage Oliverlist and/or infringe the rights of any third party;", 45, 595)

        pdf.text("III. have an up-to-date Internet browser, as well as a high-speed Internet connection, the costs of which are to be ", 45, 615)
        pdf.text("borne by them", 45, 630)

        pdf.text("IV. to make backups of all its data, prior to the first use of Oliverlist and each time it deems necessary. Aivoni ", 45, 650)
        pdf.text("can in no way be held ", 45, 665)
        pdf.text("responsible for any loss of data suffered by the Client;", 45, 680)

        pdf.text("V. not take any action to impair the reputation of Oliverlist or of Aivoni, the trademarks of Aivoni or its licensors ", 45, 700)
        pdf.text("and any other product of Aivoni or its licensors;", 45, 715)

        pdf.text("VI. use the Aivoni name and trademarks only in the manner prescribed by Aivoni in writing, unless otherwise", 45, 735)
        pdf.text(" agreed between Parties upon writing;", 45, 750)

        pdf.text("VII. inform Aivoni of any potential defects discovered when using Oliverlist;", 45, 770)

        pdf.addPage()
        pdf.text("VIII. notify Aivoni promptly of any legal notices, claims or actions directly or indirectly relating to Oliverlist and ", 45, 60)
        pdf.text("not enter into or compromise any legal action or other proceeding relating to Oliverlist without the prior ", 45, 75)
        pdf.text("written consent of Aivoni;", 45, 90)

        pdf.text("IX.  use Oliverlist for illegal purposes or in illegal manner, including in violation of the intellectual property ", 45, 110)
        pdf.text("rights of Aivoni or any third party.", 45, 125)


        //9. Confidentiality
        pdf.setFontType("bold");
        pdf.text("9. Confidentiality", 20, 150);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 160, 540, 1.5, 'F');

        pdf.setFontSize(10);
        pdf.setFontType("normal");

        pdf.text("1. Confidential Information", 35, 180);
        pdf.text("Confidential Information does not include:", 35, 195);

        pdf.text("I. Information that is currently available or that becomes available to the public without either Party breaching the ", 45, 215);
        pdf.text("General Conditions;", 45, 230);

        pdf.text("II. Information legally held by one Party before its disclosure by the other;", 45, 250);

        pdf.text("III. Information that does not come either directly or indirectly from the use of all or part of the Confidential Information;", 45, 270);

        pdf.text("IV. Information validly obtained from a third Party authorized to transfer or disclose such information.", 45, 290);

        pdf.text("2. Confidentiality Undertaking", 35, 310);

        pdf.text("The Client undertakes, in its name and in the name of its employees, agents, sub-contractors and Clients, for the duration ", 35, 330);
        pdf.text("of the General Conditions and for a period of five (5) years after the end of the General Conditions:", 35, 345);

        pdf.text("I. Not to use the Confidential Information for any purpose other than the performance of its obligations under ", 45, 365);
        pdf.text("the General Conditions;", 45, 380);

        pdf.text("II. To take all precautions that it would take with its own valuable confidential information, it being stated that ", 45, 400);
        pdf.text("such precautions  must not be less than those of a diligent professional;", 45, 415);

        pdf.text("III. Not to disclose the Confidential Information to anybody whatsoever, by any means whatsoever, except to  ", 45, 435);
        pdf.text("those of its employees, agents, service providers or sub-contractors for whom such information is necessary ", 45, 450);
        pdf.text("with a view to meeting the obligations of each  of the Parties.", 45, 465);

        pdf.text("When the General Conditions comes to an end, each Party shall return to the other Party, without delay, all ", 35, 490);
        pdf.text("Confidential Information, regardless of format, that it has obtained within the scope of the General Conditions.  ", 35, 505);
        pdf.text("Neither Party shall keep any copies in any format whatsoever, without the express prior written agreement of Aivoni.", 35, 520);

        //10. Data protection
        pdf.setFontType("bold");
        pdf.text("10. Data protection", 20, 545);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 555, 540, 1.5, 'F');

        pdf.setFontSize(10);
        pdf.setFontType("normal");

        pdf.text("1. Processing of Client Data", 35, 570);

        pdf.text("In the context of the execution of the General Conditions, Aivoni is required to process, among the Client Data, ", 35, 590);
        pdf.text("personal data in the name and on behalf of the Client.", 35, 615);

        pdf.text("Consequently, Aivoni acts as a processor, the Client being responsible for the collection and processing of this ", 35, 635);
        pdf.text("personal data.", 35, 650);

        pdf.text("The Parties entered into a contract in accordance with the provisions of Article 28 of the Regulations (EU) 2016/679", 35, 670);
        pdf.text("on the protection of natural persons with regard to the processing of personal data and on the free movement of", 35, 685);
        pdf.text("such data (the “GDPR”) as set out in Appendix A.", 35, 700);

        pdf.text("2. Data processing by Aivoni", 35, 720);

        pdf.text("In addition, Aivoni, in its relations with the Client, is required to process, on its own behalf, the personal data ", 35, 740);
        pdf.text("of the Client’s employees, managers, subcontractors, agents and/or service providers.", 35, 755);

        pdf.addPage()

        pdf.text("In this context, the Client’s staff have the right to access and, if necessary, rectify, delete or transfer data ", 35, 60);
        pdf.text("concerning them. They also have the right to define guidelines on the fate of their personal data after their death.", 35, 75);

        pdf.text("In addition, the Client’s staff may object for legitimate reasons to the processing of personal data concerning them, ", 35, 95);
        pdf.text("withdraw their consent or even limit it.", 35, 110);

        pdf.text("These rights can be exercised at any time by writing to Aivoni at the following address, contact@oliverlist.com.", 35, 130);

        pdf.text("The Client’s staff have the possibility to lodge a complaint with a supervisory authority.", 35, 150);

        pdf.text("The Client undertakes to inform its employees, managers, subcontractors, agents and/or service providers of these rights.", 35, 170);

        pdf.text("Aivoni will keep the personal data of the Client’s employees, managers, subcontractors, agents and/or service providers ", 35, 190);
        pdf.text("for a period of three (3) years from the expiry of the General Conditions.", 35, 205);

        pdf.text("Aivoni will process the said personal data on its exclusive behalf within the framework of the General Conditions and ", 35, 225);
        pdf.text("will refrain from communicating them to a third party.", 35, 240);


         //11. Reversibility
         pdf.setFontType("bold");
         pdf.text("11. Reversibility", 20, 270);
         pdf.setDrawColor(0);
         pdf.setFillColor(81, 85, 236);
         pdf.rect(20, 280, 540, 1.5, 'F');

         pdf.setFontSize(10);
         pdf.setFontType("normal");

         pdf.text("Within a period of forty-five (45) days from the expiration of the Purchase Order, the Client may export the Client ", 35, 300);
         pdf.text("Data under the conditions defined in this Article 11.", 35, 315);

         pdf.text("At the end of this reversibility period, Aivoni will proceed to the complete deletion of the personal data contained  ", 35, 335);
         pdf.text("in the Client Data, with the exception of anonymous statistical data collected by Oliverlist in the context of the ", 35, 350);
         pdf.text("provision of services to the Client.", 35, 365);


        //12. Liability
        pdf.setFontType("bold");
        pdf.text("12. Liability", 20, 395);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 405, 540, 1.5, 'F');

        pdf.setFontSize(10);
        pdf.setFontType("normal");

        pdf.text("Aivoni will use its best efforts to ensure that Oliverlist complies with the provisions of the General Terms of Use.", 35, 425);

        pdf.text("Any warranty other than the ones set forth under the General Conditions is expressly excluded by Aivoni. ", 35, 445);
        pdf.text("Specifically, Aivoni does not warrant the absence of any bugs, and as a consequence does not warrant that the use of  ", 35, 460);
        pdf.text("Oliverlist will be uninterrupted and error free. Aivoni hereby expressly disclaims the French legal warranty on  ", 35, 475);
        pdf.text("hidden defects (“garantie des vices cachés”) set for in article 1641 and seq. of the French Civil Code.", 35, 490);

        pdf.text("The Client acknowledges having a good understanding of the Internet and of its limitations. The Client agrees notably, ", 35, 510);
        pdf.text("but without limitation, that the transmissions on the Internet are not secured and can be delayed, lost, intercepted, or ", 35, 525);
        pdf.text("corrupted, and that the transmission of Confidential Information on the Internet is made by the Client at its own risks.", 35, 540);

        pdf.text("The Parties expressly agree that the provisions of this Article have been agreed between the Parties within the ", 35, 560);
        pdf.text("scope of an all-reaching negotiation process, such that each of the Parties deems them to be both justified and  ", 35, 575);
        pdf.text("proportionate with reference to the other undertakings made under the General Conditions.", 35, 590);

        pdf.text("Aivoni shall only be held liable for direct and foreseeable damage within the meaning of articles 1231-3 and 1231-4 ", 35, 610);
        pdf.text("of the French Civil Code caused by the failure of Aivoni to meet its obligations under the General Conditions.", 35, 625);

        pdf.text("The Parties expressly agree that Aivoni shall not be held liable for any loss of revenue; loss of turnover or ", 35, 645);
        pdf.text("profit; loss of clients; loss of opportunity; loss in terms of image or reputation; any costs incurred in obtaining an ", 35, 660);
        pdf.text("alternative product, software, service, or technology; or for any technical difficulties in routing messages via Internet.", 35, 675);

        pdf.text("Aivoni shall not be held liable for any damage resulting from the destruction of files or data caused by the Client", 35, 695);
        pdf.text("using one or more elements provided with Oliverlist.", 35, 710);

        pdf.text("If Aivoni should be ordered to pay a financial penalty, for any reason whatsoever, the amount of compensation ", 35, 730);
        pdf.text("awarded against it shall not exceed the total amount received by Aivoni in payments over the twelve (12) months ", 35, 755);
        pdf.text("preceding the claim.", 35, 770);



        pdf.addPage()

        pdf.text("In any case, the Client must bring a claim against Aivoni for breach of the General Conditions within a period ", 35, 60);
        pdf.text("of twelve (12) months from the date of such breach, which the Client hereby expressly acknowledges and accepts.", 35, 75);

        pdf.text("Aivoni shall under no circumstances be held liable for any damage caused by the failure of the Client to meet ", 35, 95);
        pdf.text("its own obligations.", 35, 110);

        //13. Termination
        pdf.setFontType("bold");
        pdf.text("13. Termination", 20, 140);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 150, 540, 1.5, 'F');

        pdf.setFontSize(10);
        pdf.setFontType("normal");

        pdf.text("Each Party has the right, without prejudice to any claims for compensation that it reserves the right to seek through ", 35, 170);
        pdf.text("legal means, to terminate the General Conditions and/or the Order with immediate effect in case of a material breach ", 35, 185);
        pdf.text("by the other Party of any of its essential obligations under the General Conditions, if the Party in breach fails  ", 35, 200);
        pdf.text("to remedy such breach within thirty (30) working days of receiving notice of the breach from the other Party in ", 35, 215);
        pdf.text("writing sent by registered mail with acknowledgement of receipt.", 35, 230);

        pdf.text("In the event of termination of an Order for any reason, Client shall immediately cease use of any item provided as part of ", 35, 250);
        pdf.text("the Services under such Order.", 35, 265);



        //14. Miscellaneous
        pdf.setFontType("bold");
        pdf.text("14. Miscellaneous", 20, 295);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 305, 540, 1.5, 'F');

        pdf.setFontSize(10);
        pdf.setFontType("normal");

        pdf.text("1. Assignment/transfer of the General Conditions", 35, 325);

        pdf.text("Aivoni shall have the possibility of transferring all or part of the rights and obligations resulting for it from the ", 35, 345);
        pdf.text("General Conditions to any third party of its choice, including to any subsidiary to be constituted and/or in the event of a ", 35, 360);
        pdf.text("merger, demerger, partial contribution of credit notes or total or partial transfer of its business.", 35, 375);

        pdf.text("It is expressly agreed between the Parties that any change in the capital structure of Aivoni, including a change ", 35, 395);
        pdf.text("of control, shall not affect the performance of the General Conditions.", 35, 410);

        pdf.text("The Client is not authorized to transfer all or part of its obligations under the General Conditions, in any manner ", 35, 430);
        pdf.text("whatsoever, without the prior, written, and express consent of Aivoni.", 35, 445);

        pdf.text("1. Communication – Publicity", 35, 465);

        pdf.text("The Client accepts to be featured on Aivoni’s clients reference list. Such acceptance includes being mentioned in ", 35, 485);
        pdf.text("press releases or project accounts, and the fact that the General Conditions may be used as an example of a mutually", 35, 500);
        pdf.text("beneficial collaboration for marketing purposes.", 35, 515);

        pdf.text("2. Notification – Computation of time limits", 35, 535);

        pdf.text("Any notification required or necessary pursuant to the provisions of the General Conditions shall be in writing ", 35, 555);
        pdf.text("and shall be deemed validly given if sent via e-mail to Aivoni at contact@oliverlist.com", 35, 570);

        pdf.text("Unless otherwise specified in an article of the General Conditions, the deadlines are calculated per calendar ", 35, 590);
        pdf.text("day. Any period calculated from a notification shall run from the first attempt to deliver it to the addressee, the ", 35, 605);
        pdf.text("postmark being proof.", 35, 620);

        pdf.text("3. Force Majeure", 35, 640);

        pdf.text("Neither Party shall be held liable if the performance of its obligations should be delayed, restricted, or ", 35, 660);
        pdf.text("made impossible by virtue of a case of Force Majeure.", 35, 675);

        pdf.text("If a case of Force Majeure should occur, the performance of the obligations of each Party shall be suspended. ", 35, 695);
        pdf.text("If the Force Majeure should last for more than one (1) month the General Conditions may be terminated at the request of ", 35, 710);
        pdf.text("the most diligent of the Parties, with neither Party being held liable. Each of the Parties shall bear their own costs ", 35, 725);
        pdf.text("that may be incurred as a result of the Force Majeure.", 35, 740);

        pdf.addPage()

        pdf.text("4. Suppliers – Contractors – Subcontractors", 35, 60);

        pdf.text("Throughout the duration of the General Conditions, Aivoni shall be free to use any supplier, service provider ", 35, 80);
        pdf.text("and/or subcontractor of its choice.", 35, 95);

        pdf.text("In this context, Aivoni remain, under the conditions set out in the General Conditions, responsible for ", 35, 115);
        pdf.text("the provision of the services.", 35, 130);

        pdf.text("5. Evidence", 35, 150);

        pdf.text("The computerized records will be kept in Aivoni’s computer systems under reasonable security conditions and ", 35, 170);
        pdf.text("will be considered as proof of the exchanges and/or actions carried out by Users, which the Client declares that it accepts.", 35, 185);

        pdf.text("6. Waiver", 35, 205);

        pdf.text("If one or other Party should fail to exercise any one of its rights under the General Conditions whatsoever, ", 35, 225);
        pdf.text("this shall not be deemed to be a waiver of that right, such waiver only to be deemed to have been given when expressly ", 35, 240);
        pdf.text("declared by the Party in question. ", 35, 255);

        pdf.text("7. Entirety", 35, 275);

        pdf.text("The General Conditions constitute the entire agreement between the Parties, to the exclusion of any other ", 35, 295);
        pdf.text("document, in particular those that may be issued by the Client before or after the Client’s acceptance of the General ", 35, 310);
        pdf.text("Conditions.", 35, 335);

        pdf.text("8. Validity", 35, 355);

        pdf.text("If one or more of the provisions of the General Conditions should be held to be invalid by a competent court, ", 35, 375);
        pdf.text("the remaining provisions shall retain their scope and effect.", 35, 390);

        pdf.text("The provision that has been held to be invalid shall be replaced by another provision, the scope and meaning ", 35, 420);
        pdf.text("of which shall be as close as possible to the scope and meaning of the invalidated provision, but in compliance with ", 35, 435);
        pdf.text("applicable legislation and the mutual intent of the Parties.", 35, 450)

        pdf.text("9. Change of the General Conditions ", 35, 470);

        pdf.text("Aivoni reserves the right to make, at any time, any change it deems necessary and useful to the General ", 35, 485);
        pdf.text("Conditions.", 35, 500);

        pdf.text("In the event of a change in the General Conditions, Aivoni undertakes to make the Client accept the new general ", 35, 520);
        pdf.text("conditions, fifteen (15) days before the date of their entry into force.", 35, 535);


        //15. Applicable Law- Competent jurisdiction
        pdf.setFontType("bold");
        pdf.text("15. Applicable Law- Competent jurisdiction ", 20, 565);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 575, 540, 1.5, 'F');

        pdf.setFontSize(10);
        pdf.setFontType("normal");

        pdf.text("The General Conditions are governed by French Law.", 35, 595);

        pdf.text("The Parties expressly accept to submit any dispute related to the General Conditions (understood as any dispute related ", 35, 615);
        pdf.text("to its negotiation, conclusion, enforcement, cancellation and/or termination) and/or related to the commercial ", 35, 630);
        pdf.text("relationships between the Parties and their termination, to the exclusive competence of the Paris Courts, notwithstanding ", 35, 645);
        pdf.text("plurality of defendants or warranty claims, and including summary proceedings and ex parte motions.", 35, 660);

        pdf.addPage()

         //Appendix A
         pdf.setFontType("bold");
         pdf.text("Appendix A", 280, 60);
         pdf.text("Subcontracting Agreement", 245, 90);
         pdf.setDrawColor(0);
         pdf.setFillColor(81, 85, 236);
         pdf.rect(20, 100, 550, 1.5, 'F');

         pdf.setFontSize(10);
         pdf.setFontType("normal");


        pdf.text("For all intents and purposes, all terms used in this appendix whose first letter of each word is in capital letter have the", 35, 120);
        pdf.text("same meaning as in the Aivoni General Conditions. ", 35, 135);

        pdf.text("1. Purpose of these clauses ", 35, 155);

        pdf.text("In the context of the performance of the General Conditions, Aivoni is required to process personal data among Client Data.", 35, 170);

        pdf.text("Aivoni (the “Processor”) acts as a subcontractor, the Client (the “Controller”) being responsible for the collection and ", 35, 190);
        pdf.text("processing of such personal data. ", 35, 205);

        pdf.text("The purpose of these clauses is to define the conditions under which the Processor undertakes to carry out the personal ", 35, 225);
        pdf.text("data processing operations defined below on behalf of the Controller.", 35, 240);

        pdf.text("In the context of their contractual relationship, the Parties undertake to comply with the regulations in force applicable to ", 35, 260);
        pdf.text("the processing of personal data and, in particular, Regulation (EU) 2016/679 on the protection of natural persons with regard ", 35, 275);
        pdf.text("to the processing of personal data and on the free movement of such data (the “GDPR”). ", 35, 290);

        pdf.text("2. Description of the subcontracted personal data processing ", 35, 310);

        pdf.text("The Subcontractor is authorized to process on behalf of the Controller the personal data necessary to provide the Service(s).", 35, 330);

        pdf.text("The categories of data subject are the end users of the services provided by the Client and the Users entitled to access ", 35, 350);
        pdf.text("Oliverlist by the Client.", 35, 365);

        pdf.text("The purposes of the processing are as follows: ", 35, 385);

        pdf.text("I. to provide Services;", 45, 405);

        pdf.text("II. to provide management services used by the Client; ", 45, 425);

        pdf.text("III. to compile statistics;", 45, 445);

        pdf.text("IV. to comply with applicable legislation;", 45, 465);

        pdf.text("V. to manage the Client relationship;", 45, 485);

        pdf.text("VI. to prevent fraud;", 45, 505);

        pdf.text("VII. to manage requests from data subjects for exercising their rights such as the right of access, rectification, deletion, ", 45, 525);
        pdf.text("opposition, erasure, limitation, portability, and concerning the use of personal data after the death of data subjects.", 45, 540);

        pdf.text("Unless the consent of the data subjects obtained under the conditions provided in accordance with the applicable legislation,", 35, 560);
        pdf.text("these operations  must not lead to the creation of profiles that may reveal sensitive data (racial or ethnic origins, ", 35, 575);
        pdf.text("philosophical, political, trade union, or religious opinions, sexual life or people’s health).", 35, 590);

        pdf.text("In any event, the Controller is required to previously inform the Processor of any other processing intended and to ", 35, 610);
        pdf.text("guarantee compliance with the applicable regulation. In particular, the Controller is required to carry out, if necessary, ", 35, 625);
        pdf.text("a data protection impact assessment of the processing intended under the conditions defined in Article 35 of the GDPR.", 35, 640);

        pdf.text("The personal data processed is or may be as follows, if necessary, in view of the purpose of the processing in question: ", 35, 665);

        pdf.text("I. identity (name, mail address);", 45, 685);

        pdf.text("II. data related to the profession;", 45, 705);

        pdf.text("For the performance of the Service subject of the General Conditions, the Controller shall make available to the Processor ", 35, 725);
        pdf.text("the information which guarantees compliance with the legal provisions in force and in particular the GDPR. ", 35, 740);

        pdf.text("3. Duration of these clauses ", 35, 760);

        pdf.text("These clauses take effect as from the entry into force of the General Conditions, for the duration of the General Conditions.", 35, 780);

        pdf.addPage()

        pdf.text("4. Undertakings of the Controller", 35, 60);

        pdf.text("The Controller undertakes, in the context of the performance of the General Conditions to:", 35, 80);

        pdf.text("I. transmit via the Oliverlist only Client Data strictly necessary for the provision of the Services;", 45, 100);

        pdf.text("II. document in writing any instructions regarding the processing of personal data by the Processor; ", 45, 120);

        pdf.text("III. comply with the provisions of the French law n°78-17 on Information Technology and Freedoms, the GDPR and more", 45, 140);
        pdf.text("generally the regulations applicable in France;", 45, 155);

        pdf.text("IV. supervise the processing of personal data, including through the conducting of audits in accordance with the terms ", 45, 175);
        pdf.text("previously agreed with the Processor;", 45, 190);

        pdf.text("V. ensure that there is a legal basis for the processing of personal data; ", 45, 210);

        pdf.text("VI. obtain, where applicable, the consent of the data subjects to the processing and/or transfer of their personal data;", 45, 230);

        pdf.text("VII. provide all relevant information to data subjects at the time of data collection.", 45, 250);

        pdf.text("The Processor shall not be liable for any failure by the Controller to comply with applicable regulation except where the ", 35, 270);
        pdf.text("law expressly provides otherwise.", 35, 285);

        pdf.text("5. Undertakings of the Processor ", 35, 305);

        pdf.text("In accordance with Articles 28 and 32 of the GDPR, the processor undertakes:", 35, 325);

        pdf.text("I. to take and maintain all useful measures, and in particular appropriate technical and organizational measures, to ", 45, 345);
        pdf.text("preserve the security and confidentiality of the personal data entrusted to it by the Controller for the provision of  ", 45, 360);
        pdf.text("the Services, in order to prevent them from being distorted, altered, damaged, or accessed by unauthorized persons;", 45, 375);

        pdf.text("II. to ensure that persons authorized to process personal data on their behalf, in addition to having received the necessary ", 45, 395);
        pdf.text("training in the protection of personal  data, respect confidentiality or are subject to an appropriate legal obligation of ", 45, 410);
        pdf.text("confidentiality;", 45, 425);

        pdf.text("III. to comply with applicable legal provisions relating to the conditions of processing and/or the destination of the data", 45, 445);
        pdf.text("provided  by the Controller or which it will have access to in the context of the provision of Services;", 45, 460);

        pdf.text("IV. to act only on the only documented instruction of the Controller for the processing of the personal data in question;", 45, 480);

        pdf.text("V. to use the personal data collected or to which it may have access solely for the purposes of providing the Controller ", 45, 500);
        pdf.text("with the Services;", 45, 515);

        pdf.text("VI. not to use the personal data collected or which it may have access in the context of the performance of the Contract ", 45, 535);
        pdf.text("for purposes contrary to the Contract in accordance  with the applicable regulations, and to transfer it only to a third", 45, 550);
        pdf.text("party indicated or authorized  by the Controller; ", 45, 565);

        pdf.text("VII. not to resell or transfer personal data that is strictly confidential;", 45, 585);

        pdf.text("VIII. to assist the Controller, where possible, by implementing appropriate technical and organizational measures, as well", 45, 600);
        pdf.text("as to fulfil its  obligation to respond to requests from data subjects in order to exercise their rights of access, ", 45, 615);
        pdf.text("rectification, erasure, opposition, limitation  and portability of data;", 45, 630);

        pdf.text("IX. to assist the Controller, where possible and in light of the information provided to it by the latter, to comply with ", 45, 650);
        pdf.text("its obligation to: (a) notify the supervisory authority of a personal data breach; (b) communicate a personal data breach ", 45, 665);
        pdf.text("to the data subject; (c) conduct a data protection impact assessment. ", 45, 680);

        pdf.text("The Processor may use another subcontractor to carry out specific processing activities. In this case, it shall previously ", 35, 700);
        pdf.text("inform the Controller in writing of any proposed changes concerning the addition or replacement of other subcontractors. ", 35, 715);
        pdf.text("The Controller has a minimum of seven (7) days from the date of receipt of this information to submit its objections. ", 35, 730);
        pdf.text("This subcontracting can only be carried out if the Controller has not raised  any objections within the agreed period.", 35, 745);

        pdf.text("The list of second-rank subcontractors is available here : ", 35, 765);

        pdf.text("* Apollo.io", 45, 780);

        pdf.text("* captaindata.co", 45, 795);

        pdf.addPage()

        pdf.addImage(imgLogo, 'JPEG', 20, 20, 185, 50);
        pdf.setFontSize(10);
        pdf.text(280, 30, user);
        pdf.text(280, 45, dateCreation);


        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(0, 89, 450, 18, 'F');

        pdf.setFontSize(14);
        pdf.setFontType("bold");
        pdf.setTextColor(255);
        pdf.text(215, 103, "Conditions générales d'Oliverlist");
        pdf.setFontSize(10);
        pdf.text(20, 103, 'Last Updated: 02/02/2023');

        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.setFontType("normal");



        pdf.text("Les présentes conditions générales d'Oliverlist (les 'Conditions générales') régissent les relations entre Aivoni, un " , 20, 130);
        pdf.text("société par actions simplifiée immatriculée au Registre du Commerce et des Sociétés de Nanterre sous le " , 20, 145);
        pdf.text("numéro 808 785 166, au capital de 20 000 euros, dont le siège social est situé au 4 Avenue JB Clément 92100, Boulogne-, " , 20, 160);
        pdf.text("Billancourt France ('Aivoni') et toute personne physique ou morale ayant souscrit un compte sur la solution " , 20, 175);
        pdf.text("éditée par Oliverlist (les 'Client')." , 20, 190);


        pdf.text("Ci-après dénommés collectivement les 'Les partis'et désignés individuellement comme 'Parti'." , 20, 210);


        //pdf.text("1.  Définitions, " , 20, 240);
         // 1 Definitions
        pdf.setFontType("bold");
        pdf.text("1.  Définitions", 20, 240);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 250, 540, 1.5, 'F');


        pdf.setFontType("normal");
        pdf.setFontSize(10);

        var text = "Les termes et expressions dont la première lettre est une majuscule, dans les Conditions générales, ont la signification définie dans le présent article, utilisés au singulier ou au pluriel ";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 270); // imprime las líneas de texto en la posición (20, 310) de la página

        var text = "1. 'Autorisé Utilisateurs' L'utilisateur autorisé est l'utilisateur identifié, une personne physique autorisée à accéder à Oliverlist. L'utilisateur autorisé peut être un employé, un agent et/ou un prestataire de services du client.";
        var lines = pdf.splitTextToSize(text, 530);
        pdf.text(lines, 20, 320);

        var text = "2. 'Données du client' Les données relatives aux prospects et clients du Client obtenues via Oliverlist sur la base des informations fournies par le Client.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 350);

        var text = "3. 'Informations confidentielles' On entend par 'information' toute information communiquée (par écrit, oralement ou par tout autre moyen) directement ou indirectement par le Client à Aivoni avant ou après l'entrée en vigueur des Conditions Générales, y compris, sans limitation, les informations relatives aux Services ainsi qu'aux opérations, processus, plans, savoir-faire, secrets commerciaux, inventions, techniques, opportunités commerciales et activités du Client.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 380);

        var text = "4. 'La Commission' Les sommes dues par le Client à Aivoni, telles que spécifiées dans la Commande, au titre des Services relatifs aux rendez-vous effectifs entre le Client et ses prospects tels que générés par Oliverlist.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 445);

        var text = "5. 'Force Majeure' On entend par 'événements' les événements extérieurs aux parties, imprévisibles et irrésistibles, tels que définis par la jurisprudence française.Les événements suivants sont réputés constituer un cas de force majeure (sans prétendre à une liste exhaustive) : guerre (déclarée ou non) ; acte terroriste ; invasion ; rébellion ; blocus ; sabotage ou acte de vandalisme ; grève ou conflit social, total ou partiel, extérieur aux deux Parties ; intempéries (notamment inondations, tempêtes et ouragans) ; événements déclarés 'catastrophes naturelles' ; invasion de zombies ; incendie ; épidémie ; blocages des transports ou des approvisionnements (notamment en énergie) ; défaillance des approvisionnements en énergie électrique, chauffage, climatisation, du réseau de télécommunication ou de transport de données ; défaillance des satellites.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 480);

        var text = "6. 'Conditions générales d'utilisation' désigne les manuels d'utilisation, les instructions d'utilisation, la littérature technique et tous les autres documents relatifs à l'utilisation d'Oliverlist, sous quelque forme que ce soit, fournis au Client par Aivoni dans le cadre des Conditions Générales disponibles. ";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 580);

        pdf.textWithLink("à cette URL", 332, 603, { url: "https://www.oliverlist.com/oliverlist-general-terms-of-use" });



        var text = "7. 'Taxe de licence'Les sommes dues par le Client à Aivoni, telles que spécifiées dans la Commande, au titre des Services relatifs aux Données du Client.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 625);

        var text = "8. 'Oliverlist', on entend par 'solution logicielle' la solution développée et publiée par Aivoni qui permet d'obtenir les Données du Client.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 660);

        var text = "9. 'Commande'La proposition de services soumise par Aivoni et acceptée par le client, par l'intermédiaire d'Oliverlist.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 690);

        var text = "10. 'Services'Les services fournis par Oliverlist, tels que spécifiés dans la commande, concernant la génération de leads menant à des rendez-vous B2B avec les prospects du client et/ou des fonctionnalités additionnelles relatives aux données du client.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 710);

        pdf.addPage()


        pdf.setFontType("bold");
        pdf.text("2.  Objectif", 20, 50);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 60, 540, 1.5, 'F');


        pdf.setFontType("normal");
        pdf.setFontSize(10);

        var text = "Les Conditions Générales ont pour objet de définir les termes et conditions dans lesquels Aivoni, en contrepartie du paiement de la Licence, concède au Client le droit d'utiliser Oliverlist.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 80);

        pdf.setFontType("bold");
        pdf.text("3.  Durée de l'accord", 20, 110);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 120, 540, 1.5, 'F');


        pdf.setFontType("normal");
        pdf.setFontSize(10);

        var text = "Les conditions générales entrent en vigueur à la date de signature de la première commande pour une durée indéterminée.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 140);

        var text = "Le Client peut résilier la Commande directement sur son compte sur la plateforme Oliverlist. La résiliation prendra effet à la date anniversaire mensuelle de l'activation des Services.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 170);

        //4. Accès et utilisation d'Oliverlist
        pdf.setFontType("bold");
        pdf.text("4. Accès et utilisation d'Oliverlist", 20, 210);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 220, 540, 1.5, 'F');


        pdf.setFontType("normal");
        pdf.setFontSize(10);

        pdf.text("1. Initialisation d'Oliverlist",35, 240);


        var text = "Pour s'inscrire sur Oliverlist, le client doit remplir les champs du formulaire d'inscription avec des données complètes et exactes et accepter les conditions générales.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 260);

        var text = "Les informations fournies par le Client sont utilisées pour créer le compte utilisateur principal du Client sur Oliverlist. Lors de cette phase de création du compte principal, le Client choisit l'identifiant et le mot de passe qui lui seront attachés. Dans le choix des mots de passe, Aivoni conseille au Client de respecter la recommandation de la Commission Nationale de l'Informatique et des Libertés (CNIL) sur les mots de passe afin de garantir un niveau de sécurité minimum (au moins douze caractères et quatre types différents : minuscules, majuscules, chiffres et caractères spéciaux).";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 290);

        var text = "En cas de déclaration incomplète ou erronée, les comptes du Client et des Utilisateurs Autorisés pourront être fermés de plein droit, sans préavis ni formalité. Lorsque le Client est un particulier, il déclare et garantit qu'il utilise Oliverlist dans le cadre de son activité professionnelle et qu'à ce titre, il ne peut être qualifié de consommateur au sens de l'article préliminaire du Code de la consommation.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 370);

        var text = "En cas de déclaration incomplète ou erronée, les comptes du Client et des Utilisateurs Autorisés pourront être fermés de plein droit, sans préavis ni formalité. Lorsque le Client est un particulier, il déclare et garantit qu'il utilise Oliverlist dans le cadre de son activité professionnelle et qu'à ce titre, il ne peut être qualifié de consommateur au sens de l'article préliminaire du Code de la consommation.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 430);

        pdf.text("2. Autorisation des utilisateurs",35, 490);

        var text = "Le Client s'engage à ce que les Utilisateurs Autorisés soient des personnes physiques compétentes, familiarisées avec l'utilisation des outils informatiques, professionnelles du marketing en ligne et informées par le Client de toutes les questions relatives au traitement des données personnelles et à leur utilisation dans le cadre d'activités de publicité et/ou de communication.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 510);


        pdf.text("3. Connexion/mot de passe par les utilisateurs autorisés",35, 570);

        var text = "Le Client reconnaît et accepte qu'il n'est pas possible d'accéder à Oliverlist sans entrer un login et un mot de passe. Le Client est seul responsable de la sécurité des identifiants et mots de passe fournis par Aivoni. Le Client s'engage à informer Aivoni sans délai de tout accès non autorisé, avéré ou suspecté, à un login, mot de passe à l'adresse contact@oliverlist.com. Toute action réalisée via un login attribué au Client sera réputée avoir été réalisée par le Client, sauf si le Client a préalablement déclaré le login concerné comme perdu ou volé, laissant ainsi à Aivoni un délai raisonnable pour désactiver ledit login.Dans ce cadre, le Client est responsable du respect des Conditions Générales par chacun de ses Utilisateurs Autorisés.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 590);


        pdf.addPage()

        //5. Description des services
        pdf.setFontType("bold");
        pdf.text("5. Description des services", 20, 50);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 60, 540, 1.5, 'F');


        pdf.setFontType("normal");
        pdf.setFontSize(10);


        pdf.text("1. Accès aux services", 35, 80);

        pdf.text("Oliverlist est une solution logicielle qui permet de rechercher et d'obtenir les données d'entreprises des prospects et/ou ", 35, 100);
        pdf.text("clients du  Client afin de lui permettre de créer des campagnes de ciblage.Le Client s'engage à ne partager aucun des accès ", 35, 112);
        pdf.text("d'un Utilisateur Autorisé avec un tiers. Dans ce contexte, le Client est responsable du respect des Conditions Générales par", 35, 124);
        pdf.text("chacun de ses Utilisateurs Autorisés. Le Client reconnaît avoir lu attentivement les Conditions Générales d'Utilisation ", 35, 136);
        pdf.text("disponibles ci-après", 35, 148);
        pdf.textWithLink("àcette URL ", 132, 148, { url: "https://www.oliverlist.com/oliverlist-general-terms-of-use" });
        pdf.text("et accepte d'être lié par celles-ci.", 192, 148);

        pdf.text("2. Droit d'utilisation d'Oliverlist - Propriété intellectuelle", 35, 170);

        var text = "Aivoni, en contrepartie du paiement de la Licence, accorde au Client et aux Utilisateurs Autorisés, pour la durée des Conditions Générales, le droit non exclusif, personnel et non transférable d'utiliser Oliverlist conformément aux Conditions Générales. Le Client est responsable du respect des Conditions Générales par les Utilisateurs et ne peut transférer la licence de quelque manière que ce soit sans l'accord préalable d'Aivoni.Conformément au droit d'utilisation d'Oliverlist, il est expressément interdit au Client et aux Utilisateurs Autorisés de :";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 190);

            var text = "1. analyser ou faire analyser par un tiers, au sens d'observer, d'étudier et de tester, le fonctionnement d'Oliverlist en vue d'identifier les idées et les principes sur lesquels reposent les éléments du programme lorsque Oliverlist exécute les tâches de chargement, d'affichage, d'exploitation, de transmission ou de stockage ;";
            var lines = pdf.splitTextToSize(text, 520);
            pdf.text(lines, 45, 270);

            var text = "2. dans la situation où elle aurait eu accès au code source pour quelque raison que ce soit, faire usage dudit code source de quelque manière que ce soit à l'exception du droit accordé par l'article L. 122-6-1 du Code de la propriété intellectuelle toute interaction d'Aivoni à cet égard étant subordonnée au paiement par cette dernière des coûts associés ;";
            var lines = pdf.splitTextToSize(text, 520);
            pdf.text(lines, 45, 310);

            var text = "3. modifier, améliorer, traduire Oliverlist, y compris pour corriger des bugs ou des erreurs, Aivoni se réservant exclusivement ce droit conformément à l'article L. 122-6-1 I 2° du Code de la Propriété Intellectuelle ;";
            var lines = pdf.splitTextToSize(text, 520);
            pdf.text(lines, 45, 365);

            var text = "4. transférer, louer, sous-louer, vendre, mettre en gage ou céder tout ou partie du titre de propriété d'Oliverlist de quelque manière que ce soit ;";
            var lines = pdf.splitTextToSize(text, 520);
            pdf.text(lines, 45, 395);

            var text = "5. ne pas fournir de services par l'intermédiaire d'Oliverlist à un tiers - autre qu'un utilisateur - de quelque manière que ce soit, y compris, mais sans s'y limiter, à un bureau de services, à un fournisseur de services d'application (ASP), à un logiciel en tant que service (SaaS) ou à une externalisation.";
            var lines = pdf.splitTextToSize(text, 520);
            pdf.text(lines, 45, 430);

            pdf.text("3. Savoir-faire", 35, 490);

            var text = "Toutes les idées, le savoir-faire ou les techniques qui peuvent être développés par Aivoni, y compris les améliorations ou les modifications apportées aux programmes informatiques d'Aivoni, sont la propriété exclusive d'Aivoni. Aivoni peut, à sa seule discrétion, développer, utiliser, commercialiser et licencier tout logiciel ou matériel de traitement de données qui est similaire ou lié aux développements d'Aivoni pour le Client. Aivoni n'a aucune obligation de divulguer les idées, le savoir-faire ou les techniques qu'il peut développer et qu'il considère comme exclusifs et confidentiels.";
            var lines = pdf.splitTextToSize(text, 520);
            pdf.text(lines, 35, 510);



        //6. Conditions financières
        pdf.setFontType("bold");
        pdf.text("6. Conditions financières", 20, 600);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 610, 540, 1.5, 'F');


        pdf.setFontType("normal");
        pdf.setFontSize(10);

        pdf.text("1. Licence et commissions", 35, 630);

        var text = "L'accès à Oliverlist est soumis à la fourniture par le Client d'un moyen de paiement valide tel que défini dans les Conditions Générales d'Utilisation.En contrepartie de l'utilisation d'Oliverlist, le Client devra payer à Aivoni la Commission et, le cas échéant, le Droit de Licence.La Commission est calculée en fonction du nombre de rendez-vous programmés par le Client via Oliverlist dans les conditions spécifiées dans les Conditions Générales d'Utilisation.Le Droit de Licence est déterminé lors de la souscription du Service correspondant via Oliverlist.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 650);


        pdf.addPage()

        pdf.text("2. Conditions de paiement", 35, 50);

        var text = "Pour la fourniture des Services, (i) les Droits de licence sont payables d'avance sur une base mensuelle ; et (ii) la Commission est facturée et due dès qu'un rendez-vous est considéré comme effectif et est payée dans les conditions prévues dans les Conditions générales d'utilisation. Le droit de licence et/ou la commission ne comprennent pas les taxes, droits de douane, tarifs, taxe sur la valeur ajoutée ou toute autre taxe applicable, qui doivent être payés par le client en sus :";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 70);


        var text = "1. toute somme restée impayée sera de plein droit productive d'intérêts, s'accumulant quotidiennement jusqu'à la date de paiement intégral du principal, des intérêts, des frais et des coûts supplémentaires, à un taux égal à cinq (5) fois le taux d'intérêt légal applicable, et ce sans qu'aucune autre mise en demeure ne soit nécessaire et sans préjudice de toute demande d'indemnisation qu'Aivoni se réserve le droit de solliciter par voie judiciaire ;";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 45, 150);


        var text = "2. Aivoni se réserve le droit, à sa seule discrétion, avec ou sans préavis, de suspendre l'exécution de tout Service, actuel ou futur, et ce jusqu'au paiement intégral des sommes dues ;";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 45, 200);

        var text = "3. Tout retard dans le paiement des factures entraînera l'application immédiate d'un taux d'intérêt annuel de 12% sur les montants impayés ainsi que quarante (40) euros par facture pour les frais de recouvrement, conformément à l'art. L 4414-10 du Code de commerce ; et";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 45, 230);

        var text = "4. toutes les sommes restant dues par le Client à Aivoni deviennent immédiatement exigibles.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 45, 270);


         //7. Responsabilité d'Aivoni
         pdf.setFontType("bold");
         pdf.text("7. Responsabilité d'Aivoni", 20, 320);
         pdf.setDrawColor(0);
         pdf.setFillColor(81, 85, 236);
         pdf.rect(20, 330, 540, 1.5, 'F');


         pdf.setFontType("normal");
         pdf.setFontSize(10);

         var text = "Les Services seront fournis dans le cadre des Conditions Générales par Aivoni qui s'engage, sauf stipulation expresse contraire, à faire preuve de diligence raisonnable.Sauf stipulation expresse contraire, les obligations d'Aivoni au titre des Conditions Générales sont des obligations de moyens.Aivoni s'engage à ce que l'ensemble de son personnel mette en œuvre son savoir-faire et ses connaissances en vue de la bonne exécution des Services. En cas de difficultés dans la fourniture des Services, Aivoni s'engage à en informer immédiatement le Client.Aivoni se réserve le droit de modifier à tout moment les caractéristiques de ses infrastructures techniques, le choix de ses fournisseurs techniques et la composition de ses équipes.";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 35, 350);


        //8. Responsabilités du client
          pdf.setFontType("bold");
          pdf.text("8. Responsabilités du client", 20, 450);
          pdf.setDrawColor(0);
          pdf.setFillColor(81, 85, 236);
          pdf.rect(20, 460, 540, 1.5, 'F');


          pdf.setFontType("normal");
          pdf.setFontSize(10);

          pdf.text("Le client s'engage à :", 20, 480);

         var text = "1. se conformer strictement aux instructions d'utilisation énoncées dans les conditions générales d'utilisation ;";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 35, 500);

         var text = "2. ne pas importer dans Oliverlist des données susceptibles de nuire à Oliverlist et/ou de violer les droits d'un tiers ;";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 35, 520);

         var text = "3. disposer d'un navigateur Internet à jour, ainsi que d'une connexion Internet à haut débit, dont les coûts sont à leur charge";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 35, 540);

         var text = "4. à effectuer des sauvegardes de toutes ses données, avant la première utilisation d'Oliverlist et chaque fois qu'il le jugera nécessaire. Aivoni ne peut en aucun cas être tenu responsable de toute perte de données subie par le Client ;";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 35, 570);

         var text = "5. ne pas prendre de mesures visant à nuire à la réputation d'Oliverlist ou d'Aivoni, des marques de commerce d'Aivoni ou de ses concédants et de tout autre produit d'Aivoni ou de ses concédants ;";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 35, 600);

         var text = "6. utiliser le nom et les marques d'Aivoni uniquement de la manière prescrite par Aivoni par écrit, sauf accord écrit contraire entre les parties ;";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 35, 635);

         var text = "7. informer Aivoni de tout défaut potentiel découvert lors de l'utilisation d'Oliverlist ;";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 35, 670);

         var text = "8. notifier rapidement à Aivoni toute notification légale, réclamation ou action directement ou indirectement liée à Oliverlist et ne pas entamer ou compromettre une action légale ou autre procédure liée à Oliverlist sans le consentement écrit préalable d'Aivoni ;";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 35, 690);

         var text = "9. ne pas utiliser Oliverlist à des fins illégales ou de manière illégale, y compris en violation des droits de propriété intellectuelle d'Aivoni ou de tout autre tiers.";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 35, 730);

         pdf.addPage();

         //9. Confidentialité
         pdf.setFontType("bold");
         pdf.text("9. Confidentialité", 20, 50);
         pdf.setDrawColor(0);
         pdf.setFillColor(81, 85, 236);
         pdf.rect(20, 60, 540, 1.5, 'F');


         pdf.setFontType("normal");
         pdf.setFontSize(10);

         pdf.text("1. Informations confidentielles", 20, 80);

         pdf.text("Les informations confidentielles ne comprennent pas", 35, 100);

              var text = "1. Les informations qui sont actuellement disponibles ou qui deviennent accessibles au public sans que l'une ou l'autre des parties n'enfreigne les conditions générales ;";
              var lines = pdf.splitTextToSize(text, 520);
              pdf.text(lines, 45, 120);

              var text = "2. Informations détenues légalement par une partie avant leur divulgation par l'autre partie ;";
              var lines = pdf.splitTextToSize(text, 520);
              pdf.text(lines, 45, 150);

              var text = "3. Les informations qui ne proviennent pas directement ou indirectement de l'utilisation de tout ou partie des informations confidentielles ;";
              var lines = pdf.splitTextToSize(text, 520);
              pdf.text(lines, 45, 170);

              var text = "4. Les informations valablement obtenues d'un tiers autorisé à transférer ou à divulguer ces informations.";
              var lines = pdf.splitTextToSize(text, 520);
              pdf.text(lines, 45, 205);

          pdf.text("2. Engagement de confidentialité", 20, 230);

          var text = "Le Client s'engage, en son nom et au nom de ses employés, agents, sous-traitants et Clients, pour la durée des Conditions Générales et pour une période de cinq (5) ans après la fin des Conditions Générales :";
          var lines = pdf.splitTextToSize(text, 520);
          pdf.text(lines, 35, 250);

              var text = "1. Ne pas utiliser les informations confidentielles à d'autres fins que l'exécution de ses obligations au titre des conditions générales ;";
              var lines = pdf.splitTextToSize(text, 520);
              pdf.text(lines, 45, 280);

              var text = "2. Prendre toutes les précautions qu'elle prendrait avec ses propres informations confidentielles de valeur, étant entendu que ces précautions ne doivent pas être moindres que celles d'un professionnel diligent ;";
              var lines = pdf.splitTextToSize(text, 520);
              pdf.text(lines, 45, 315);

              var text = "3. Ne pas divulguer les informations confidentielles à qui que ce soit, par quelque moyen que ce soit, sauf à ses employés, agents, prestataires de services ou sous-traitants pour lesquels ces informations sont nécessaires en vue de satisfaire aux obligations de chacune des parties.";
              var lines = pdf.splitTextToSize(text, 520);
              pdf.text(lines, 45, 350);

          var text = "A l'expiration des Conditions Générales, chaque Partie restituera à l'autre Partie, sans délai, toutes les Informations Confidentielles, quel qu'en soit le format, qu'elle a obtenues dans le cadre des Conditions Générales. Aucune des Parties ne conservera de copies sous quelque format que ce soit, sans l'accord exprès, préalable et écrit d'Aivoni.";
          var lines = pdf.splitTextToSize(text, 520);
          pdf.text(lines, 35, 400);


         //10.Protection des données
         pdf.setFontType("bold");
         pdf.text("10.Protection des données", 20, 460);
         pdf.setDrawColor(0);
         pdf.setFillColor(81, 85, 236);
         pdf.rect(20, 470, 540, 1.5, 'F');


         pdf.setFontType("normal");
         pdf.setFontSize(10);

         pdf.text("1. Traitement des données des clients", 20, 490);

         var text = "Dans le cadre de l'exécution des Conditions Générales, Aivoni est amenée à traiter, parmi les Données Client, des données personnelles au nom et pour le compte du Client.";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 20, 510);

        var text = "Par conséquent, Aivoni agit en tant que sous-traitant, le Client étant responsable de la collecte et du traitement de ces données personnelles.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 540);

        var text = "Les Parties ont conclu un contrat conformément aux dispositions de l'article 28 du Règlement (UE) 2016/679 relatif à la protection des personnes physiques à l'égard du traitement des données à caractère personnel et à la libre circulation de ces données (le 'RGPD') comme indiqué à l'annexe A.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 570);

        pdf.text("2. Traitement des données par Aivoni", 20, 620);


        var text = "En outre, Aivoni, dans ses relations avec le Client, est amené à traiter, pour son propre compte, les données à caractère personnel des employés, dirigeants, sous-traitants, agents et/ou prestataires de services du Client.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 640);

        var text = "Dans ce cadre, le personnel du client dispose d'un droit d'accès et, le cas échéant, de rectification, d'effacement et de portabilité des données le concernant. Ils ont également le droit de définir des directives sur le sort de leurs données à caractère personnel après leur décès.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 670);

        var text = "En outre, le personnel du client peut s'opposer, pour des raisons légitimes, au traitement des données à caractère personnel le concernant, retirer son consentement ou même le limiter.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 710);

        var text = "Ces droits peuvent être exercés à tout moment en écrivant à Aivoni à l'adresse suivante : contact@oliverlist.com.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 740);

        pdf.addPage();

        var text = "Le personnel du client a la possibilité d'introduire une réclamation auprès d'une autorité de contrôle.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 50);

        var text = "Le Client s'engage à informer ses employés, dirigeants, sous-traitants, agents et/ou prestataires de services de ces droits.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 70);

        var text = "Aivoni conservera les données personnelles des employés, dirigeants, sous-traitants, agents et/ou prestataires de services du Client pendant une période de trois (3) ans à compter de l'expiration des Conditions Générales.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 100);

        var text = "Aivoni traitera ces données personnelles pour son compte exclusif dans le cadre des Conditions Générales et s'abstiendra de les communiquer à un tiers.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 130);


         //11. Reversibilité
         pdf.setFontType("bold");
         pdf.text("11. Reversibilité", 20, 160);
         pdf.setDrawColor(0);
         pdf.setFillColor(81, 85, 236);
         pdf.rect(20, 170, 540, 1.5, 'F');

         pdf.setFontType("normal");
         pdf.setFontSize(10);

         var text = "Dans un délai de quarante-cinq (45) jours à compter de l'expiration du Bon de commande, le Client peut exporter les Données du Client dans les conditions définies au présent article 11.";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 20, 190);

        var text = "A l'issue de cette période de réversibilité, Aivoni procédera à la suppression complète des données personnelles contenues dans les Données Client, à l'exception des données statistiques anonymes collectées par Oliverlist dans le cadre de la fourniture de services au Client.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 220);

         //12. Responsabilité
         pdf.setFontType("bold");
         pdf.text("12. Responsabilité", 20, 270);
         pdf.setDrawColor(0);
         pdf.setFillColor(81, 85, 236);
         pdf.rect(20, 280, 540, 1.5, 'F');

         pdf.setFontType("normal");
         pdf.setFontSize(10);


        var text = "Aivoni fera ses meilleurs efforts pour s'assurer que Oliverlist respecte les dispositions des conditions générales d'utilisation.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 300);

        var text = "Toute garantie autre que celles énoncées dans les conditions générales est expressément exclue par Aivoni. En particulier, Aivoni ne garantit pas l'absence de bogues, et en conséquence ne garantit pas que l'utilisation d'Oliverlist sera ininterrompue et exempte d'erreurs. Aivoni renonce expressément à la garantie légale française des vices cachés ('garantie des vices cachés') prévue aux articles 1641 et suivants du Code civil français.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 330);

        var text = "Le Client reconnaît avoir une bonne compréhension de l'Internet et de ses limites. Le client convient notamment, mais sans s'y limiter, que les transmissions sur Internet ne sont pas sécurisées et peuvent être retardées, perdues, interceptées ou corrompues, et que la transmission d'informations confidentielles sur Internet est effectuée par le client à ses propres risques.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 385);

        var text = "Les Parties conviennent expressément que les dispositions du présent article ont été convenues entre les Parties dans le cadre d'un processus de négociation global, de sorte que chacune des Parties les considère comme justifiées et proportionnées par rapport aux autres engagements pris dans le cadre des Conditions générales.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 440);

        var text = "Aivoni n'est responsable que des dommages directs et prévisibles au sens des articles 1231-3 et 1231-4 du Code civil français causés par le manquement d'Aivoni à ses obligations au titre des Conditions Générales.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 485);

        var text = "Les Parties conviennent expressément qu'Aivoni ne peut être tenu responsable de toute perte de revenus, perte de chiffre d'affaires ou de bénéfices, perte de clientèle, perte d'opportunité, perte en termes d'image ou de réputation, de tout coût encouru pour obtenir un produit, un logiciel, un service ou une technologie de remplacement, ou de toute difficulté technique dans l'acheminement des messages via Internet.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 520);

        var text = "Aivoni ne pourra être tenu responsable de tout dommage résultant de la destruction de fichiers ou de données causée par l'utilisation par le Client d'un ou plusieurs éléments fournis avec Oliverlist.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 580);

        var text = "Si Aivoni est condamnée à une sanction financière, pour quelque raison que ce soit, le montant de l'indemnité qui lui est allouée ne peut excéder le montant total des paiements reçus par Aivoni au cours des douze (12) mois précédant la réclamation.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 615);

        var text = "En tout état de cause, le Client doit introduire une réclamation contre Aivoni pour violation des Conditions Générales dans un délai de douze (12) mois à compter de la date de cette violation, ce que le Client reconnaît et accepte expressément par les présentes.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 660);

        var text = "Aivoni ne pourra en aucun cas être tenu responsable des dommages causés par le non-respect par le Client de ses propres obligations.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 710);


        pdf.addPage()
        //13. Cessation d'activité
        pdf.setFontType("bold");
        pdf.text("13. Cessation d'activité", 20, 50);
        pdf.setDrawColor(0);
        pdf.setFillColor(81, 85, 236);
        pdf.rect(20, 60, 540, 1.5, 'F');

        pdf.setFontType("normal");
        pdf.setFontSize(10);

        var text = "Chaque partie a le droit, sans préjudice des demandes d'indemnisation qu'elle se réserve le droit de solliciter par voie judiciaire, de résilier les conditions générales et/ou la commande avec effet immédiat en cas de violation substantielle par l'autre partie de l'une quelconque de ses obligations essentielles au titre des conditions générales, si la partie en infraction ne remédie pas à cette violation dans un délai de trente (30) jours ouvrables à compter de la réception de la notification de l'infraction par l'autre partie, par écrit et par lettre recommandée avec accusé de réception.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 80);

        var text = "En cas de résiliation d'une commande pour quelque raison que ce soit, le client cesse immédiatement d'utiliser tout élément fourni dans le cadre des services au titre de ladite commande.";
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 150);

         //14. Divers
         pdf.setFontType("bold");
         pdf.text("14. Divers", 20, 190);
         pdf.setDrawColor(0);
         pdf.setFillColor(81, 85, 236);
         pdf.rect(20, 200, 540, 1.5, 'F');

         pdf.setFontType("normal");
         pdf.setFontSize(10);

         pdf.text("1. Cession/transfert des conditions générales", 20, 220);

         var text = "Aivoni aura la possibilité de transférer tout ou partie des droits et obligations résultant pour elle des Conditions Générales à tout tiers de son choix, y compris à toute filiale à constituer et/ou en cas de fusion, scission, apport partiel d'avoirs ou cession totale ou partielle de son activité.";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 20, 240);

         var text = "Il est expressément convenu entre les parties que tout changement dans la structure du capital d'Aivoni, y compris un changement de contrôle, n'affectera pas l'exécution des conditions générales.";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 20, 280);

         var text = "Le Client n'est pas autorisé à transférer tout ou partie de ses obligations au titre des Conditions Générales, de quelque manière que ce soit, sans l'accord préalable, écrit et exprès d'Aivoni.";
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 20, 310);


        pdf.text("2. Communication - Publicité", 20, 340);

        var text = "Le Client accepte de figurer sur la liste de référence des clients d'Aivoni. Cette acceptation inclut le fait d'être mentionné dans les communiqués de presse ou les comptes-rendus de projets, et le fait que les Conditions Générales peuvent être utilisées comme un exemple de collaboration mutuellement bénéfique à des fins de marketing."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 360);

        pdf.text("3. Notification - Calcul des délais", 20, 415);

        var text = "Toute notification requise ou nécessaire en vertu des dispositions des conditions générales doit être faite par écrit et est considérée comme valide si elle est envoyée par courrier électronique à Aivoni à l'adresse suivante : contact@oliverlist.com."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 435);

        var text = "Sauf disposition contraire dans un article des Conditions générales, les délais sont calculés par jour calendrier. Tout délai calculé à partir d'une notification court à partir de la première tentative de remise au destinataire, le cachet de la poste faisant foi."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 480);

        pdf.text("4. Force Majeure", 20, 530);

        var text = "Aucune des parties ne sera tenue responsable si l'exécution de ses obligations est retardée, restreinte ou rendue impossible en raison d'un cas de force majeure."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 550);

        var text = "Si un cas de force majeure survient, l'exécution des obligations de chaque partie est suspendue. Si le cas de force majeure dure plus d'un (1) mois, les conditions générales peuvent être résiliées à la demande de la plus diligente des parties, sans que la responsabilité de l'une ou l'autre des parties puisse être engagée. Chacune des Parties supportera ses propres frais qui pourraient résulter de la Force Majeure."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 580);

        pdf.text("5. Fournisseurs - Entrepreneurs - Sous-traitants", 20, 640);

        var text = "Pendant toute la durée des conditions générales, Aivoni est libre de faire appel à tout fournisseur, prestataire de services et/ou sous-traitant de son choix."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 660);

        var text = "Dans ce contexte, Aivoni reste, dans les conditions prévues par les conditions générales, responsable de la fourniture des services."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 690);

        pdf.text("6. Preuves", 20, 725);

        var text = "Les registres informatisés seront conservés dans les systèmes informatiques d'Aivoni dans des conditions raisonnables de sécurité et seront considérés comme des preuves des échanges et/ou actions effectués par les Utilisateurs, ce que le Client déclare accepter."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 745);


        pdf.addPage()

        pdf.text("7. Renonciation", 20, 50);

        var text = "Le fait pour l'une ou l'autre des parties de ne pas exercer l'un quelconque des droits que lui confèrent les conditions générales ne saurait être considéré comme une renonciation à ce droit, cette renonciation n'étant réputée acquise qu'après déclaration expresse de la partie en cause."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 70);


        pdf.text("8. Intégralité", 20, 110);

        var text = "Les conditions générales constituent l'intégralité de l'accord entre les parties, à l'exclusion de tout autre document, notamment ceux qui pourraient être émis par le client avant ou après l'acceptation des conditions générales par le client."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 130);

        pdf.text("9. Validité", 20, 170);

        var text = "Si une ou plusieurs dispositions des conditions générales sont déclarées nulles par un tribunal compétent, les autres dispositions conservent leur portée et leur effet."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 190);

        var text = "La disposition invalidée est remplacée par une autre disposition dont la portée et le sens sont aussi proches que possible de la portée et du sens de la disposition invalidée, mais dans le respect de la législation applicable et de l'intention mutuelle des parties."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 220);

        pdf.text("10. Modification des conditions générales", 20, 265);

        var text = "Aivoni se réserve le droit d'apporter, à tout moment, toute modification qu'elle juge nécessaire et utile aux conditions générales."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 285);

        var text = "En cas de modification des Conditions Générales, Aivoni s'engage à faire accepter au Client les nouvelles conditions générales, quinze (15) jours avant la date de leur entrée en vigueur."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 320);

        //15. Droit applicable - Juridiction compétente
         pdf.setFontType("bold");
         pdf.text("15. Droit applicable - Juridiction compétente", 20, 360);
         pdf.setDrawColor(0);
         pdf.setFillColor(81, 85, 236);
         pdf.rect(20, 370, 540, 1.5, 'F');

         pdf.setFontType("normal");
         pdf.setFontSize(10);

         var text = "Les conditions générales sont régies par le droit français."
         var lines = pdf.splitTextToSize(text, 520);
         pdf.text(lines, 20, 390);

        var text = "Les Parties acceptent expressément de soumettre tout litige relatif aux Conditions Générales (entendu comme tout litige relatif à sa négociation, sa conclusion, son exécution, son annulation et/ou sa résiliation) et/ou relatif aux relations commerciales entre les Parties et à leur rupture, à la compétence exclusive des Tribunaux de Paris, nonobstant pluralité de défendeurs ou appel en garantie, et y compris les procédures de référé et de ex parte motions."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 410);

        pdf.setFontType("bold");
        pdf.setFontSize(14);

        pdf.text("ANNEXE A", 20, 490);

        pdf.setFontSize(12);

        pdf.text("Accord de sous-traitance", 20, 530);

        pdf.setFontType("normal");
        pdf.setFontSize(10);

        var text = "A toutes fins utiles, tous les termes utilisés dans la présente annexe dont la première lettre de chaque mot est en majuscule ont la même signification que dans les conditions générales d'Aivoni."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 550);

        pdf.text("1. Objet de ces clauses", 20, 580);

        var text = "Dans le cadre de l'exécution des conditions générales, Aivoni est tenue de traiter des données à caractère personnel parmi les données des clients."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 600);

        var text = "Aivoni (le 'Processeur') agit en tant que sous-traitant, le client (le 'Contrôleur') qui est responsable de la collecte et du traitement de ces données à caractère personnel."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 630);

        var text = "Ces clauses ont pour objet de définir les conditions dans lesquelles le sous-traitant s'engage à effectuer les traitements de données à caractère personnel définis ci-dessous pour le compte du responsable du traitement."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 660);

        var text = "Dans le cadre de leur relation contractuelle, les Parties s'engagent à respecter la réglementation en vigueur applicable au traitement des données à caractère personnel et, en particulier, le règlement (UE) 2016/679 relatif à la protection des personnes physiques à l'égard du traitement des données à caractère personnel et à la libre circulation de ces données (le 'GDPR')."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 690);


        pdf.addPage()

        pdf.text("2. Description du traitement de données à caractère personnel sous-traité", 20, 50);

        var text = "Le sous-traitant est autorisé à traiter, pour le compte du contrôleur, les données à caractère personnel nécessaires pour fournir le(s) service(s)."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 70);

        var text = "Les catégories de personnes concernées sont les utilisateurs finaux des services fournis par le client et les utilisateurs autorisés à accéder à Oliverlist par le client."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 100);

        pdf.text("Les finalités du traitement sont les suivantes :", 20, 130);

        pdf.text("1. pour fournir des services ;", 35, 150);

        pdf.text("2. fournir des services de gestion utilisés par le client ;", 35, 170);

        pdf.text("3. pour établir des statistiques ;", 35, 190);

        pdf.text("4. pour se conformer à la législation en vigueur ;", 35, 210);

        pdf.text("5. pour gérer la relation avec le client ;", 35, 230);

        pdf.text("6. pour prévenir la fraude ;", 35, 250);

        var text = "7. gérer les demandes des personnes concernées pour l'exercice de leurs droits tels que le droit d'accès, de rectification, de suppression, d'opposition, d'effacement, de limitation, de portabilité, et concernant l'utilisation des données à caractère personnel après le décès des personnes concernées."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 270);


        var text = "Sauf consentement des personnes concernées obtenu dans les conditions prévues par la législation applicable, ces opérations ne doivent pas conduire à la création de profils susceptibles de révéler des données sensibles (origines raciales ou ethniques, opinions philosophiques, politiques, syndicales ou religieuses, vie sexuelle ou santé des personnes)."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 315);

        var text = "En tout état de cause, le responsable du traitement est tenu d'informer préalablement le sous-traitant de tout autre traitement envisagé et de garantir le respect de la réglementation applicable. En particulier, le responsable du traitement est tenu d'effectuer, si nécessaire, une analyse d'impact sur la protection des données du traitement envisagé dans les conditions définies à l'article 35 du RGPD."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 370);

        var text = "Les données à caractère personnel traitées sont ou peuvent être les suivantes, si nécessaire, compte tenu de la finalité du traitement en question :"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 425);

        pdf.text("1. l'identité (nom, adresse postale) ;", 35, 460);
        pdf.text("2. les données relatives à la profession ;", 35, 490);

        var text = "Pour l'exécution du service soumis aux conditions générales, le responsable du traitement met à la disposition du sous-traitant les informations qui garantissent le respect des dispositions légales en vigueur et en particulier du GDPR."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 510);

        pdf.text("3. Durée de ces clauses", 20, 560);

        pdf.text("Ces clauses prennent effet à partir de l'entrée en vigueur des conditions générales, pour la durée des conditions générales.", 20, 580);

        pdf.text("4. Engagements du contrôleur", 20, 600);

        pdf.text("Le contrôleur s'engage, dans le cadre de l'exécution des conditions générales, à :", 20, 620);

        var text = "1. ne transmettre via l'Oliverlist que les données du client strictement nécessaires à la fourniture des services ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 640);

        var text = "2. documenter par écrit toute instruction concernant le traitement des données à caractère personnel par le sous-traitant ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 660);

        var text = "3. respecter les dispositions de la loi n°78-17 relative à l'informatique et aux libertés, le GDPR et plus généralement la réglementation applicable en France ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 690);

        var text = "4. superviser le traitement des données à caractère personnel, y compris par la réalisation d'audits conformément aux conditions préalablement convenues avec le sous-traitant ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 720);

        var text = "5. s'assurer qu'il existe une base juridique pour le traitement des données à caractère personnel ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 750);

        pdf.addPage()

        var text = "6. obtenir, le cas échéant, le consentement des personnes concernées au traitement et/ou au transfert de leurs données à caractère personnel ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 50);

        var text = "7. fournir toutes les informations pertinentes aux personnes concernées au moment de la collecte des données."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 80);

        var text = "Le sous-traitant n'est pas responsable du non-respect par le responsable du traitement de la réglementation applicable, sauf si la loi en dispose expressément autrement."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 110);


        pdf.text("5.Engagements du sous-traitant", 20, 150);

        pdf.text("Conformément aux articles 28 et 32 du RGPD, le sous-traitant s'engage :", 20, 170);

        var text = "1. prendre et maintenir toutes les mesures utiles, et notamment les mesures techniques et organisationnelles appropriées, pour préserver la sécurité et la confidentialité des données à caractère personnel qui lui sont confiées par le responsable du traitement pour la fourniture des services, afin d'empêcher qu'elles soient déformées, altérées, endommagées ou que des personnes non autorisées y aient accès ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 190);

        var text = "2. s'assurer que les personnes autorisées à traiter des données à caractère personnel en leur nom, en plus d'avoir reçu la formation nécessaire à la protection des données à caractère personnel, respectent la confidentialité ou sont soumises à une obligation légale appropriée de confidentialité ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 245);

        var text = "3. respecter les dispositions légales applicables relatives aux conditions de traitement et/ou à la destination des données fournies par le contrôleur ou auxquelles il aura accès dans le cadre de la fourniture des services ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 290);

        var text = "4. à n'agir que sur la seule instruction documentée du contrôleur pour le traitement des données personnelles en question ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 320);

        var text = "5. à utiliser les données à caractère personnel collectées ou auxquelles il peut avoir accès uniquement dans le but de fournir les services au contrôleur ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 360);

        var text = "6. à ne pas utiliser les données personnelles collectées ou auxquelles il pourrait avoir accès dans le cadre de l'exécution du Contrat à des fins contraires au Contrat conformément à la réglementation applicable, et à ne les transférer qu'à un tiers indiqué ou autorisé par le Responsable du traitement ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 390);

        var text = "7. ne pas revendre ou transférer des données personnelles qui sont strictement confidentielles ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 430);

        var text = "8. aider le responsable du traitement, dans la mesure du possible, à mettre en œuvre les mesures techniques et organisationnelles appropriées, ainsi qu'à s'acquitter de son obligation de répondre aux demandes des personnes concernées en vue d'exercer leurs droits d'accès, de rectification, d'effacement, d'opposition, de limitation et de portabilité des données ;"
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 450);

        var text = "9. d'aider le responsable du traitement, dans la mesure du possible et à la lumière des informations que ce dernier lui a fournies, à se conformer à ses obligations : (a) notifier à l'autorité de contrôle une violation de données à caractère personnel ; (b) communiquer une violation de données à caractère personnel à la personne concernée ; (c) réaliser une analyse d'impact relative à la protection des données."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 35, 505);

        var text = "Le sous-traitant peut faire appel à un autre sous-traitant pour effectuer des activités de traitement spécifiques. Dans ce cas, il informe préalablement le responsable du traitement par écrit de tout changement proposé concernant l'ajout ou le remplacement d'autres sous-traitants. Le responsable du traitement dispose d'un délai minimum de sept (7) jours à compter de la date de réception de cette information pour présenter ses objections. Cette sous-traitance ne peut être effectuée que si le responsable du traitement n'a pas formulé d'objections dans le délai convenu."
        var lines = pdf.splitTextToSize(text, 520);
        pdf.text(lines, 20, 570);

        pdf.text("La liste des sous-traitants de second rang est disponible ici :", 20, 640);

        pdf.text("* Apollo.io", 35, 660);
        pdf.text("* captaindata.co", 35, 680);




        // Export file pdf
        pdf.save('Terms&Conditions.pdf');

     }
   }
}
